import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { withTranslation } from "react-i18next";
import Select from "react-select";

import { useRule } from "./hooks/useRule";

import "css/admin/conditional_render.scss";

function ConditionalRenderForm({
  conditions,
  onChange,
  operator,
  predicat,
  rank,
  type,
  t,
}) {
  const [tooltip, setTooltip] = useState(false);

  const { typeOptions, operatorOptions, predicatOptions } = useRule(
    type,
    operator,
    predicat,
    conditions,
  );

  const getOption = (option, options) =>
    options.find((opt) => opt.value === option) || null;

  const showOptionLabel = (option, currentPredicat) => {
    if (option.isDisabled && !currentPredicat) {
      return (
        <div
          className="select-predicat-option"
          onMouseOver={() => setTooltip(true)}
          onMouseLeave={() => setTooltip(false)}
        >
          <span> {t(option.label)}</span>
          <i className="material-icons warn-condition">warning</i>
        </div>
      );
    }

    return <span> {t(option.label)} </span>;
  };

  const currentType = getOption(type, typeOptions);
  const currentOperator = getOption(operator, operatorOptions);
  const currentPredicat = getOption(predicat, predicatOptions);

  return (
    <div className="conditional-render-form-container editor-select">
      <Select
        isDisabled={typeOptions.length === 1}
        name="form-field-name"
        closeMenuOnSelect
        value={currentType}
        getOptionLabel={(option) => t(option.label)}
        onChange={(type) => onChange("type", type.value, rank)}
        options={typeOptions}
        placeholder={t("select")}
        className="select-conditional-render-type conditional-render-form-line-item"
        classNamePrefix="slct"
      />
      <Select
        name="form-field-name"
        closeMenuOnSelect
        value={currentOperator}
        getOptionLabel={(option) => t(option.label)}
        onChange={(operator) => onChange("operator", operator.value, rank)}
        options={operatorOptions}
        placeholder={t("select")}
        className="select-conditional-render-operator conditional-render-form-line-item"
        classNamePrefix="slct"
      />
      <div className="select-predicat-condition editor-tooltip editor-tooltip-center">
        <Select
          name="form-field-name"
          closeMenuOnSelect
          value={currentPredicat}
          getOptionLabel={(option) => showOptionLabel(option, currentPredicat)}
          onChange={(predicat) => onChange("predicat", predicat.value, rank)}
          options={predicatOptions}
          placeholder={t("select")}
          className="select-conditional-render-predicat conditional-render-form-line-item"
          classNamePrefix="slct"
        />
        {tooltip && (
          <span className="editor-tooltiptext editor-tooltiptext-center">
            {t("conflict_with")}
          </span>
        )}
      </div>
    </div>
  );
}

ConditionalRenderForm.propTypes = {
  conditions: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  operator: PropTypes.string,
  predicat: PropTypes.string,
  rank: PropTypes.number,
  t: PropTypes.func.isRequired,
  type: PropTypes.string,
};

ConditionalRenderForm.defaultProps = {
  type: "user",
  operator: "",
  predicat: "",
  rank: 0,
};

export default withTranslation("conditional-render")(ConditionalRenderForm);
